// Phase 99 — shared Project Category constants + grouping helper.
// Used by Projects.jsx, ProjectWizard.jsx, DailyTasksWidget.jsx (Quick Add
// Task's 3 project dropdowns), TaskArchiveTab.jsx and the Finance "Burn by
// Project Category" chart, so every screen agrees on the same 3 buckets.
export const PROJECT_CATEGORIES = [
  { value: "client_delivery", label: "Client Delivery" },
  { value: "studio_operations", label: "Studio Operations" },
  { value: "marketing_sales", label: "Marketing & Sales" },
];

export const PROJECT_CATEGORY_LABEL = Object.fromEntries(PROJECT_CATEGORIES.map((c) => [c.value, c.label]));

export function isActiveProject(p) {
  return p && p.status !== "completed" && p.status !== "archived";
}

// Groups a project list into { client_delivery: [...], studio_operations: [...], marketing_sales: [...] }
// preserving PROJECT_CATEGORIES order. Projects with an unknown/missing
// category fall back into Studio Operations so nothing silently disappears.
export function groupProjectsByCategory(projects) {
  const groups = Object.fromEntries(PROJECT_CATEGORIES.map((c) => [c.value, []]));
  for (const p of projects || []) {
    const cat = PROJECT_CATEGORY_LABEL[p.category] ? p.category : "studio_operations";
    groups[cat].push(p);
  }
  return groups;
}
